export enum EmailNotificationEvent {
  PitchedStatus = 'PitchedStatus',
  ProcessingStatus = 'ProcessingStatus',
  UnderwritingStatus = 'UnderwritingStatus',
  ApprovedStatus = 'ApprovedStatus',
  FundedStatus = 'FundedStatus',
  RejectedStatus = 'RejectedStatus',
}

export enum StatusLabel {
  Pitched = 'Pitched',
  Processing = 'Processing',
  Underwriting = 'Underwriting',
  Approved = 'Approved',
  Funded = 'Funded',
  Rejected = 'Rejected',
}
